import { Box, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import { COMPETITION_META } from "../../../../helpers/competitionMeta";
import "./CompetitionCard.css";

const CompetitionCard = ({
  item,
  index = 0,
  categoryTitle = "We Do Challenge",
  accent = "#c11a83",
  onClick,
}) => {
  const meta = COMPETITION_META[item.link] || {};
  const Icon = meta.icon || ScienceOutlinedIcon;

  return (
    <Box
      className="competitionCard"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
      sx={{ "--competition-accent": accent }}
    >
      <Box className="competitionCardInner">
        <Box className="competitionCardMedia">
          <Box
            component="img"
            src={item.image}
            alt={item.title}
            className="competitionCardImage"
          />
          <Box className="competitionCardMediaOverlay" />
          {/* <Box className="competitionCardIndex">
            {String(index + 1).padStart(2, "0")}
          </Box> */}
          <Box className="competitionCardIconBadge">
            <Icon sx={{ fontSize: 18 }} />
          </Box>
        </Box>

        <Box className="competitionCardContent">
          <Box className="competitionCardMeta">
            <Typography className="competitionCardCategory">
              {categoryTitle}
            </Typography>
            <Typography className="competitionCardAge">{item.age}</Typography>
          </Box>

          <Typography className="competitionCardTitle">{item.title}</Typography>

          {meta.description && (
            <Typography className="competitionCardDescription">
              {meta.description}
            </Typography>
          )}

          <Box className="competitionCardFooter">
            <span>Explore competition</span>
            <ArrowForwardIcon className="competitionCardArrow" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CompetitionCard;
